
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showDownloads, setShowDownloads] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  // 根据路径获取页面标题
  const getPageTitle = () => {
    const path = location.pathname;
    
    if (path === '/' || path === '/overview') {
      return '概览';
    }
    
    if (path === '/manufacturer/list') {
      return '厂商管理 - 厂商列表';
    }
    
    if (path === '/supplier/list') {
      return '供应商管理 - 供应商列表';
    }
    
    if (path === '/model/list') {
      return '模型管理 - 模型列表';
    }
    
    if (path === '/model/resource') {
      return '模型管理 - 模型资源';
    }
    
    if (path === '/category/list') {
      return '模型管理 - 类别列表';
    }
    
    if (path === '/parameter/list') {
      return '模型管理 - 参数列表';
    }
    
    if (path === '/series/list') {
      return '模型管理 - 系列列表';
    }
    
    if (path === '/user/list') {
      return '用户管理 - 用户列表';
    }
    
    if (path === '/order/list') {
      return '订单管理 - 订单列表';
    }
    
    if (path === '/order/after-sales') {
      return '订单管理 - 售后列表';
    }
    
    if (path === '/data/consumption') {
      return '数据中心 - 消费数据';
    }
    
    if (path === '/data/call') {
      return '数据中心 - 调用数据';
    }
    
    if (path === '/system/payment') {
      return '系统管理 - 支付管理';
    }
    
    if (path === '/system/log') {
      return '系统管理 - 系统日志';
    }
    
    if (path === '/permission/role') {
      return '权限 - 角色列表';
    }
    
    if (path === '/permission/user') {
      return '权限 - 用户列表';
    }
    
    return '控制台';
  };

  const notifications = [
    { id: 1, title: '系统更新通知', content: '系统将于今晚22:00进行维护更新', time: '2小时前', unread: true },
    { id: 2, title: '订单提醒', content: '您有3个新订单待处理', time: '4小时前', unread: true },
    { id: 3, title: '用户反馈', content: '收到新的用户反馈信息', time: '1天前', unread: false },
  ];

  const downloads = [
    { id: 1, name: '用户数据报表.xlsx', size: '2.3MB', status: 'completed', time: '刚刚' },
    { id: 2, name: '订单统计.pdf', size: '1.8MB', status: 'downloading', progress: 75, time: '2分钟前' },
    { id: 3, name: '系统日志.zip', size: '5.2MB', status: 'completed', time: '10分钟前' },
  ];

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h2 className="text-xl font-semibold text-gray-900">{getPageTitle()}</h2>
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <span>当前时间:</span>
            <span>{new Date().toLocaleString('zh-CN')}</span>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          {/* 通知中心 */}
          <div className="relative">
            <button
              className="relative p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <i className="ri-notification-line w-5 h-5"></i>
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                2
              </span>
            </button>
            
            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="p-4 border-b border-gray-200">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-gray-900">通知中心</h3>
                    <Button variant="ghost" size="sm">全部已读</Button>
                  </div>
                </div>
                <div className="max-h-96 overflow-y-auto">
                  {notifications.map(notification => (
                    <div key={notification.id} className={`p-4 border-b border-gray-100 hover:bg-gray-50 cursor-pointer ${notification.unread ? 'bg-blue-50/30' : ''}`}>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <h4 className="font-medium text-gray-900 text-sm">{notification.title}</h4>
                          <p className="text-gray-600 text-sm mt-1">{notification.content}</p>
                          <span className="text-gray-400 text-xs mt-2 block">{notification.time}</span>
                        </div>
                        {notification.unread && (
                          <div className="w-2 h-2 bg-blue-500 rounded-full mt-1"></div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="p-3 border-t border-gray-200">
                  <Button variant="ghost" size="sm" className="w-full">查看全部通知</Button>
                </div>
              </div>
            )}
          </div>

          {/* 下载中心 */}
          <div className="relative">
            <button
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              onClick={() => setShowDownloads(!showDownloads)}
            >
              <i className="ri-download-line w-5 h-5"></i>
            </button>
            
            {showDownloads && (
              <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="p-4 border-b border-gray-200">
                  <h3 className="font-semibold text-gray-900">下载中心</h3>
                </div>
                <div className="max-h-96 overflow-y-auto">
                  {downloads.map(download => (
                    <div key={download.id} className="p-4 border-b border-gray-100 hover:bg-gray-50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                            <i className="ri-file-line text-blue-600"></i>
                          </div>
                          <div>
                            <h4 className="font-medium text-gray-900 text-sm">{download.name}</h4>
                            <div className="flex items-center space-x-2 text-xs text-gray-500 mt-1">
                              <span>{download.size}</span>
                              <span>•</span>
                              <span>{download.time}</span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center space-x-2">
                          {download.status === 'downloading' ? (
                            <div className="flex items-center space-x-2">
                              <div className="w-16 bg-gray-200 rounded-full h-1">
                                <div className="bg-blue-600 h-1 rounded-full" style={{ width: `${download.progress}%` }}></div>
                              </div>
                              <span className="text-xs text-gray-500">{download.progress}%</span>
                            </div>
                          ) : (
                            <i className="ri-check-line text-green-500"></i>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="p-3 border-t border-gray-200">
                  <Button variant="ghost" size="sm" className="w-full">查看全部下载</Button>
                </div>
              </div>
            )}
          </div>

          {/* 用户菜单 */}
          <div className="relative">
            <button
              className="flex items-center space-x-2 p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-medium">管</span>
              </div>
              <span className="text-sm font-medium">管理员</span>
              <i className="ri-arrow-down-s-line w-4 h-4"></i>
            </button>
            
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="p-2">
                  <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-pointer">
                    <i className="ri-user-line w-4 h-4 mr-2"></i>
                    个人资料
                  </button>
                  <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md cursor-pointer">
                    <i className="ri-settings-line w-4 h-4 mr-2"></i>
                    系统设置
                  </button>
                  <hr className="my-2" />
                  <button className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md cursor-pointer">
                    <i className="ri-logout-box-line w-4 h-4 mr-2"></i>
                    退出登录
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
